import { useAddCompareList } from "../ComparePage/useAddCompareList";
import { useSelector } from "react-redux";
import { useCompare } from "../../context/CompareContext";
import { useState } from "react";

export const useDetailPageDetails = (props = {}) => {
  const { product, configProductVariantId } = props;
  const { isSignedIn } = useSelector((state) => state.loginSlice);
  const [showBookVisitSite, setShowBookVisitSite] = useState(false);

  const productLink = `/product/${product.url_key}.html}`;
  const share_url = `${document.location.origin}${productLink}`;
  const productId =
    product.__typename === "ConfigurableProduct"
      ? configProductVariantId
      : product.id;

  const compareTalonProps = useAddCompareList({ productId });

  const { addToCompare } = compareTalonProps;
  const { data: compareData } = useCompare();

  const isInCompare = compareData
    ? compareData.some((item) => item.product.id === productId)
    : false;

  return {
    share_url,
    addToCompare,
    isSignedIn,
    isInCompare,
    showBookVisitSite,
    setShowBookVisitSite,
  };
};
